import { IFormErrors } from '@interfaces/IFormsErrors';
import { IPeriod, IPeriodWithHolidays } from '@interfaces/IPeriod';

export interface IPeriodsViewState {
  periods: IPeriodWithHolidays[] | null;
  isLoading: boolean;
  errors: IFormErrors | null;
  period: {
    data: IPeriod | null;
    isLoading: boolean;
    errors: IFormErrors | null;
  };
}

export const initialsPeriodsViewState: IPeriodsViewState = {
  periods: null,
  period: {
    data: null,
    isLoading: false,
    errors: null,
  },
  isLoading: false,
  errors: null,
};
